export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Global configuration for application assets
export const APP_CONFIG = {
    ILLUSTRATION_URL: process.env.REACT_APP_ILLUSTRATION_URL,

    CLOUDINARY_CLOUD_NAME: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME,
    CLOUDINARY_PRESET: process.env.REACT_APP_CLOUDINARY_PRESET,

    APP_ENV: process.env.REACT_APP_ENV,
};